import React, { useEffect } from "react"
import {Alert, Col, Row, Card, CardBody, CardTitle, UncontrolledAlert} from "reactstrap"
import { connect } from "react-redux";
import { Link, Redirect, useNavigate, useLocation } from 'react-router-dom';
import { setBreadcrumbItems } from "../../store/actions";
import imgdark from "../../assets/images/logo-dark.png";
const Success = (props) => {
  document.title = "Opérations | Enregistrement réussi";
  const navigate = useNavigate();
  const location = useLocation();
  const { operation } = location.state || {};
  const breadcrumbItems = [
    // { title: "Lexa", link: "#" },
    // { title: "UI Elements", link: "#" },
    // { title: "Alerts", link: "#" },
  ]

  useEffect(() => {props.setBreadcrumbItems('Enregistrement Réussie', breadcrumbItems)})

  const handlePrint = () => {
    const content = document.getElementById("print-zone").innerHTML;
    const printWindow = window.open("", "_blank", "width=600,height=800");
    printWindow.document.write(`
      <html>
        <head>
          <title>Impression</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { border-collapse: collapse; }
            td { padding: 4px 8px; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  return (
    <React.Fragment>

      <Row>
        <Col xl={12}>
          <Card>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm={4}>
                    <div id="print-zone" color="success" className="alert-dismissible fade show mt-4 px-4 mb-0" role="alert">
                      <img src={imgdark} alt="logo" height="100" />
                      <h2 className="text-black">{operation?.opAgexp?.agEtp?.etpNom}</h2>
                      <h3 className="text-black">Code colis: </h3>  
                      <h2 style={{ fontWeight: "bold" }} className="text-black">{operation.opCode} </h2>
                      <table>
                        <tbody>
                          <tr><td>Créé le</td><td style={{ fontWeight: "bold" }}>{operation.opCreate}</td></tr>
                          <tr><td>Gare de départ</td><td style={{ fontWeight: "bold" }}>{operation.opAgexp?.agNom}</td></tr>
                          <tr><td>Destination</td><td style={{ fontWeight: "bold" }}>{operation.opAgdest?.agNom}</td></tr>
                          <tr><td>Emballage</td><td style={{ fontWeight: "bold" }}>{operation.detail[0]?.opdEmbal?.embalLibelle}</td></tr>
                          <tr><td>Description</td><td style={{ fontWeight: "bold" }}>{operation.detail[0]?.opdNature?.natLibelle}</td></tr>
                          <tr><td>Expéditeur</td><td style={{ fontWeight: "bold" }}>{operation.opExp}</td></tr>
                          <tr><td>Contact</td><td style={{ fontWeight: "bold" }}>{operation.opPhonexp}</td></tr>
                          <tr><td>Bénéficiaire</td><td style={{ fontWeight: "bold" }}>{operation.opExp}</td></tr>
                          <tr><td>Contact</td> <td style={{ fontWeight: "bold" }}>{operation.opDestphone}</td></tr>
                          <tr><td>Valeur</td><td style={{ fontWeight: "bold" }}>{operation.detail[0]?.opdColval} FCFA</td></tr>
                          <tr><td>Frais</td><td style={{ fontWeight: "bold" }}>{operation.detail[0]?.opdFrais} FCFA</td></tr>
                        </tbody>
                      </table>
                      
                    </div>
                    <button type="button" className="btn btn-primary mt-3" onClick={handlePrint}><i className="fa fa-print"></i> Imprimer</button>
                  </Col>

                </Row>
              </div>

            </CardBody>
          </Card>

          <Card>
            <Col sm={12}>
                <button type="button" style={{ width: "100%" }} onClick={()=>{navigate('/operations')}} className="btn btn-lg d-block btn-warning" id="liveAlertBtn">FAIRE UN NOUVEL ENREGISTREMENT</button>
            </Col>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Success);